import { render, staticRenderFns } from "./PackList.vue?vue&type=template&id=6bce06e6&scoped=true&"
import script from "./PackList.vue?vue&type=script&lang=js&"
export * from "./PackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bce06e6",
  null
  
)

export default component.exports